import React from 'react';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function PostLaunchTruth() {
  return <section className="py-16 md:py-20 bg-paper-dark border-y border-gray-200 relative" data-id="element-362">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-363">
        <PathThread data-id="element-364" />
      </div>
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-365">
        <Reveal data-id="element-366">
          <h2 className="text-2xl md:text-4xl font-serif text-navy mb-10 leading-tight" data-id="element-367">
            The book can look successful{' '}
            <span className="italic text-seaglass" data-id="element-368">
              and still feel underused
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-369">
          <div className="text-lg text-text-muted leading-relaxed space-y-5 mb-14" data-id="element-370">
            <p data-id="element-371">A serious nonfiction book is not a small thing.</p>
            <p data-id="element-372">
              It carries your thinking, stories, frameworks, language, point of
              view, and years of work most people never see.
            </p>
            <p data-id="element-373">So the problem is not that the book failed.</p>
            <p data-id="element-374">
              The book may have done its first job. It created credibility. It
              gave people a reason to trust you.
            </p>
            <p data-id="element-375">But credibility alone does not tell a reader what to do next.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-376">
          <div className="relative" data-id="element-377">
            <div className="w-10 h-0.5 bg-sand rounded-full mx-auto mb-7" data-id="element-378"></div>
            <p className="text-2xl md:text-3xl font-serif text-navy leading-snug" data-id="element-379">
              "The book may have worked. <br className="hidden md:block" data-id="element-380" />
              <span className="italic text-seaglass" data-id="element-381">
                The path after it may be what was missing.
              </span>
              "
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}